import { render, staticRenderFns } from "./WorkMate.vue?vue&type=template&id=0ddf21e6"
import script from "./WorkMate.vue?vue&type=script&lang=ts"
export * from "./WorkMate.vue?vue&type=script&lang=ts"
import style0 from "./WorkMate.vue?vue&type=style&index=0&id=0ddf21e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports